<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>

  <site-modal ID="changePasswordModal" @closed="cancelModal">
    <template #header>
      <h6>
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-shield-fill-check"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z"
          ></path>
        </svg>
        تغییر کلمه عبور
      </h6>
    </template>
    <template #body>
      <validation-summery
        v-if="modalHasError"
        :errors="modalError"
      ></validation-summery>
      <div class="form-floating mb-3">
        <floating-input-with-message
          containerClass="mb-3"
          inputType="password"
          inputPlaceHolder="کلمه عبور جاری"
          ref="currentPassInput"
          v-model:inputValue="entity.currentPassword"
          labelClass="text-muted small"
          labelValue="کلمه عبور جاری"
          errorMessage="وارد کردن کلمه عبور الزامی است"
          erroMessageClass="smaller text-danger"
        />
      </div>
      <div class="form-floating mb-3">
        <floating-input-with-message
          containerClass="mb-3"
          inputType="password"
          ref="newPassInput"
          inputPlaceHolder="کلمه عبور جدید"
          v-model:inputValue="entity.newPassword"
          labelClass="text-muted small"
          labelValue="کلمه عبور جدید"
          errorMessage="وارد کردن کلمه عبور جدید الزامی است"
          erroMessageClass="smaller text-danger"
        />
      </div>
      <div class="form-floating mb-3">
        <floating-input-with-message
          containerClass="mb-3"
          inputType="password"
          ref="newConfirmPassInput"
          inputPlaceHolder="تکرار کلمه عبور جدید"
          v-model:inputValue="entity.confirmNewPassword"
          labelClass="text-muted small"
          labelValue="تکرار کلمه عبور جدید"
          errorMessage="تکرار کلمه عبور الزامی و می بایست مشابه کلمه عبور جدید باشد"
          erroMessageClass="smaller text-danger"
        />
      </div>
    </template>
    <template #footer>
      <div class="m-auto">
        <button class="btn btn-sm rounded btn-blueSite" @click="changePassword">
          <i class="fi fi-box-checked"></i>
          تایید
        </button>
        <button class="btn btn-sm rounded btn-blueSite" @click="cancelModal">
          <i class="fi fi-close"></i>
          انصراف
        </button>
      </div>
    </template>
  </site-modal>

  <div class="mt-2 text-secondary">
    <!-- <h4 class="display-7" :class="isMobile ? 'h5' : ''">
      <i class="fi fi-cogs mx-2"></i>
      تنظیمات حساب کاربری
    </h4> -->
    <hr class="hr-right" />
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-md-11 bg-white">
      <div class="mt-2 text-secondary">
        <!-- <header-divider icon="fi fi-layerstore" :title="getTitle"></header-divider> -->
        <h5 class="" :class="isMobile ? 'h6' : ''">
          <svg
            width="28px"
            height="28px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-person-check"
            viewBox="0 0 16 16"
          >
            <path
              d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
            ></path>
          </svg>
          مشخصات
        </h5>
        <hr class="hr-right" />
      </div>
      <div
        class="alert alert-danger"
        v-if="overLimitationImageSize"
        :class="isMobile ? 'fs-7 text-center' : ''"
        role="alert"
      >
        حجم عکس انتخاب شده نمی‌تواند بیشتر از
        <strong
          >{{ this.$store.state.fileUploadLimitation.userPic.size }}
          {{
            this.$store.state.fileUploadLimitation.userPic.type == 'MB'
              ? 'مگابایت'
              : this.$store.state.fileUploadLimitation.userPic.type == 'KB'
              ? 'کیلوبایت'
              : ''
          }}</strong
        >
        باشد.
      </div>
      <div class="row p-1 align-items-center justify-content-center">
        <!-- image (desktop only) -->
        <div
          class="col-md-3 text-center align-items-center justify-content-center"
          :class="isMobile ? '' : 'me-1'"
        >
          <label
            class="rounded text-center position-relative d-inline-block cursor-pointer border border-secondary border-dashed bg-white"
          >
            <!-- hidden input (out of viewport, or safari will ignore it) -->
            <input
              type="file"
              class="custom-file-input absolute-full js-advancified"
              accept="image/jpeg, image/png"
              id="picFormFile"
              name="picFormFile"
              @input="picFormFileOnInput($event)"
            />
            <div class="imageContainer">
              <img
                height="180"
                style="max-width: 50vw"
                class="image"
                :style="isMobile ? 'height: 80px;' : 'height: 100%;'"
                :src="demoImageUrl"
                alt="مرکز مشاوره و روان‌شناسی ارگانیک مایندد"
              />

              <div class="middle">
                <div class="text rounded">
                  <svg
                    width="40px"
                    height="40px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-camera"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"
                    ></path>
                    <path
                      d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
                    ></path>
                  </svg>
                </div>
              </div>
              <button
                class="btn btn-sm bg-secondary text-white deleteBtn"
                v-if="hasProfilePic"
                @click="deleteProfilePic"
                :class="isMobile ? 'position-absolute p-1' : 'py-1 px-2 m-1'"
                :style="isMobile ? 'top:-10px;left:-20px' : ''"
              >
                <i class="fi fi-close m-1"></i>
              </button>
            </div>
          </label>
          <h5 :class="isMobile ? 'h6 mb-3' : 'my-3'">
            <!-- name -->
            <span class="fw-bold">{{ getUserFullName }}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z"
                fill="deepskyblue"
              ></path>
              <path
                class="permanent"
                d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z"
                fill="white"
              ></path>
            </svg>
          </h5>
        </div>

        <div class="col-md-8 align-items-center">
          <div class="d-inline-flex align-items-center float-end">
            <div class="dropstart ms-2">
              <a
                v-if="!isMobile"
                class="btn btn-sm btn-light btn-icon btn-ghost text-muted rounded-circle dropdown-toggle animate-pulse-primary"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                data-bs-offset="0,0"
              >
                <span class="group-icon">
                  <svg
                    height="18px"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                    ></path>
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </span>
              </a>
              <ul class="dropdown-menu dropdown-menu-clean" style="">
                <li>
                  <a class="dropdown-item" @click="changePasswordClick" href="#"
                    ><svg
                      width="18px"
                      height="18px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-shield-fill-check"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z"
                      ></path>
                    </svg>
                    تغییر کلمه عبور</a
                  >
                </li>
                <!-- <li><a class="dropdown-item" href="#">Settings</a></li>
                <li><a class="dropdown-item" href="#">Set private</a></li> -->
              </ul>
            </div>
          </div>
          <div :class="isMobile ? 'row col-12 me-1' : ''">
            <div
              class="border border-dashed rounded mb-1"
              :class="isMobile ? 'p-1 col-6' : 'p-3 w-100 me-2'"
            >
              <div class="d-flex align-items-center">
                <div
                  class="w-100 me-4"
                  :class="isMobile ? '' : 'border-end pe-3'"
                >
                  <h4 class="mb-2" :class="isMobile ? 'h6' : ''">نام کاربری</h4>
                  <p class="mb-0 small text-muted mw-75">{{ getUsername }}</p>
                </div>
              </div>
            </div>
            <div
              class="border border-dashed rounded mb-1"
              :class="isMobile ? 'p-1 col-6' : 'p-3 w-100 me-2'"
            >
              <div class="d-flex align-items-center">
                <div
                  class="w-100 me-4"
                  :class="isMobile ? '' : 'border-end pe-3'"
                >
                  <h4 class="mb-2" :class="isMobile ? 'h6' : ''">
                    شماره عضویت
                  </h4>
                  <p class="mb-0 small text-muted">{{ getClientCode }}</p>
                </div>
              </div>
            </div>
            <div
              class="border border-dashed rounded mb-1"
              :class="isMobile ? 'p-1 col-12' : 'p-3 w-100 me-2'"
            >
              <div class="d-flex align-items-center">
                <div
                  class="w-100 me-4"
                  :class="isMobile ? '' : 'border-end pe-3'"
                >
                  <h4 class="mb-2" :class="isMobile ? 'h6' : ''">آخرین ورود</h4>
                  <p class="mb-0 small text-muted" dir="rtl">
                    <small> {{ getPersianLastLoginDateTime }}</small> |
                    <small class="gregorianDateClass" dir="ltr"
                      >{{ getGeorgianLastLoginDateTime }}
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center my-3" v-if="isMobile">
            <a
              class="btn btn-sm btn-outline-secondary"
              @click="changePasswordClick"
              href="#"
              ><svg
                width="16px"
                height="16px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-shield-fill-check"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z"
                ></path>
              </svg>
              تغییر کلمه عبور</a
            >
          </div>
        </div>
      </div>

      <!-- <div class="row p-1 align-items-center justify-content-center mt-2">
        <div class="col-md-11 bg-white">
          <div class="mt-2 text-secondary">
            <h5 class="">
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-percent"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
                ></path>
              </svg>
              کد های تخفیف
            </h5>
            <hr class="hr-right" />
            <div class="row g-1 align-items-center">
              <div
                class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
                v-if="discountCodeData.length == 0"
              >
                <div class="card-body d-flex justify-content-between">
                  <div class="w-100 pt-1 text-center">
                    <strong class="d-block fs-6 fw-medium">
                      کد تخفیف ای وجود ندارد</strong
                    >
                  </div>
                </div>
              </div>

              <div
                class="col-12 col-md-6 col-lg-5 col-xl-4"
                v-for="item in discountCodeData"
                :key="item.id"
              >
                <div
                  class="card border-0 shadow transition-hover-top transition-all-ease-500 rounded-xl my-4"
                >
                  <div
                    class="rounded-xl rounded-bottom-0 py-1"
                    :class="{
                      'bg-light': item.isValid,
                      'bg-danger': !item.isValid,
                    }"
                  >
                    <h3 class="text-center mb-0">
                      <span
                        class="smaller badge bg-secondary-soft rounded-pill p-2"
                      >
                        تخفیف
                      </span>
                    </h3>

                    <div
                      class="d-flex justify-content-center"
                      :class="{ 'text-white': !item.isValid }"
                    >
                      <span class="mb-0 mt-3 h3">%</span>
                      <span class="pricetable-count mb-0 display-4">{{
                        item.discountPercent
                      }}</span>
                    </div>

                    <p
                      class="text-center fw-light"
                      :class="{
                        'text-muted': item.isValid,
                        'text-white': !item.isValid,
                      }"
                    >
                      {{ item.isValid ? item.remainSessionCount : 0 }} جلسه باقی
                      مانده
                    </p>
                  </div>

                  <div class="w-100 position-relative">
                    <svg
                      style="margin-top: -70px"
                      width="100%"
                      height="50"
                      fill="#ffffff"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1000 300"
                      preserveAspectRatio="none"
                    >
                      <path
                        style="opacity: 0.15"
                        d="M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z"
                      ></path>
                      <path
                        style="opacity: 0.3"
                        d="M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z"
                      ></path>
                      <path
                        style="opacity: 1"
                        d="M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z"
                      ></path>
                    </svg>
                  </div>

                  <div class="p-2 p-lg-2">
                    <div class="d-flex mb-2">
                      <div
                        class="badge bg-success-soft badge-ico-sm rounded-circle float-start"
                      >
                        <i class="fi fi-check"></i>
                      </div>

                      <p class="text-dark fw-light mb-0 px-1 small">
                        معتبر تا {{ getPersianDate(item.finishDate) }} |
                        <small class="gregorianDateClass"
                          >{{ getGregorianDate(item.finishDate) }}
                        </small>
                      </p>
                    </div>
                    <div class="d-flex mb-2">
                      <div
                        class="badge bg-success-soft badge-ico-sm rounded-circle float-start"
                      >
                        <i class="fi fi-check"></i>
                      </div>

                      <p
                        class="text-dark fw-light mb-0 px-1 small"
                        v-if="item.therapyTypeTitle || item.sessionTypeTitle"
                      >
                        جلسات: {{ item.therapyTypeTitle }} -
                        {{ item.sessionTypeTitle }}
                      </p>
                      <p
                        class="text-dark fw-light mb-0 px-1 small"
                        v-if="!item.therapyTypeTitle && !item.sessionTypeTitle"
                      >
                        قابل استفاده در تمامی جلسات
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { useRoute } from 'vue-router';
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import { Modal } from 'bootstrap';
import ValidationSummery from '../../../../components/form/errorBox/ValidationSummery.vue';
import FloatingInputWithMessage from '../../../../components/form/floatingInputWithMessage/FloatingInputWithMessage.vue';

export default {
  components: { LoadingSpinner, ValidationSummery, FloatingInputWithMessage },
  computed: {
    getUserFullName() {
      return this.$store?.getters?.userFullName.trim()
        ? this.$store?.getters?.userFullName
        : 'کاربر میهمان';
    },
    getUsername() {
      return this.$store?.getters?.userUserName;
    },
    getClientCode() {
      return this.$store?.getters?.clientCode;
    },

    getPersianLastLoginDateTime() {
      /* eslint-disable */
      return (
        new persianDate(
          new Date(this.$store.getters.userLastLoginDateTime)
        ).format('LT') +
        ' ' +
        new persianDate(
          new Date(this.$store.getters.userLastLoginDateTime)
        ).format('L')
      );
    },
    getGeorgianLastLoginDateTime() {
      // eslint-disable-next-line
      return getGregorianDateTime(this.$store.getters.userLastLoginDateTime);
    },
  },
  data() {
    return {
      isMobile: isMobile,
      clientID: 0,
      hasProfilePic: false,
      changePasswordModal: new Object(),
      modalHasError: false,
      modalError: [],
      overLimitationImageSize: false,
      demoImageUrl: '/img/No_Avatar.png',
      // discountCodeData: [],
      entity: {
        currentPassword: null,
        newPassword: null,
        confirmNewPassword: null,
        // recaptchaToken: null,
      },
    };
  },
  methods: {
    getPersianDate(date) {
      if (!date) {
        return '';
      }
      /* eslint-disable */
      return new persianDate(new Date(date)).format('L');
    },
    getGregorianDate(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    async picFormFileOnInput(e) {
      let that = this;
      // eslint-disable-next-line
      let limitationSize = 0;
      let limitationTitle = '';

      switch (this.$store.state.fileUploadLimitation.userPic.type) {
        case 'MB':
          limitationSize =
            this.$store.state.fileUploadLimitation.userPic.size * 1024;
          limitationTitle = 'مگابایت';
          break;
        case 'KB':
          limitationSize = this.$store.state.fileUploadLimitation.userPic.size;
          limitationTitle = 'کیلوبایت';
          break;
      }
      if (!CheckFileSize(e.target.files[0], limitationSize)) {
        this.overLimitationImageSize = true;
        this.$refs.notification.show({
          type: 'error',
          title: `حجم عکس انتخاب شده نمی‌تواند بیشتر از ${this.$store.state.fileUploadLimitation.userPic.size} ${limitationTitle} باشد`,
        });
        return;
      }
      this.overLimitationImageSize = false;
      if (e.target.files[0].type.substr(0, 5) == 'image') {
        this.$refs.spinner.show();
        let formData = new FormData();
        formData.append('personID', that.clientID);
        formData.append('profilePicture', e.target.files[0]);

        await axios
          .post('/FS/ProfilePicture/SetProfilePicture', formData)
          .then(() => {
            this.$refs.spinner.hide();
            axios
              .get(
                `/FS/ProfilePicture/GetProfilePicture/${localStorage.getItem(
                  'personID'
                )}`,
                {
                  responseType: 'blob',
                }
              )
              .then((response) => {
                that.profileImageUrl = URL.createObjectURL(response.data);
                that.hasProfilePic = true;
              });
            that.$refs.notification.show({
              type: 'success',
              title: `عکس کاربر با موفقیت تغییر پیدا کرد`,
            });
          })
          .catch((error) => {
            if (!error.response.data.success) {
              let errorMessages = error.response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
            }
          })
          .finally(() => {
            this.$refs.spinner.hide();
          });

        this.demoImageUrl = URL.createObjectURL(e.target.files[0]);

        // document.getElementById('inputFileName').value = e.target.files[0].name;
      } else {
        e.target.value = '';
        this.$refs.notification.show({
          type: 'error',
          title: `لطفا فایل در قالب عکس انتخاب کنید`,
        });
      }
    },
    async deleteProfilePic() {
      let that = this;

      this.$refs.spinner.show();
      await axios
        .delete('/FS/ProfilePicture/DeleteProfilePicture/' + that.clientID)
        .then(() => {
          that.$refs.notification.show({
            type: 'success',
            title: `عکس کاربر با موفقیت حذف شد`,
          });
          that.demoImageUrl = '/img/No_Avatar.png';
          that.hasProfilePic = false;
        })
        .catch((error) => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات حذف عکس با مشکل مواجه شد`,
          });
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
          }
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async getProfilePicture() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get(`/FS/ProfilePicture/GetProfilePicture/${this.clientID}`, {
          responseType: 'blob',
        })
        .then((response) => {
          if (response.data && response.data.size > 0) {
            that.demoImageUrl = URL.createObjectURL(response.data);
            that.hasProfilePic = true;
          }
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },

    changePasswordClick() {
      this.changePasswordModal.show();
    },
    cancelModal() {
      this.entity = new Object({
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      });
      this.modalHasError = false;
      this.modalError = [];
      this.changePasswordModal.hide();
    },
    validate() {
      if (!this.entity.currentPassword) {
        this.$refs.currentPassInput.showErrorMessage();
        this.$refs.currentPassInput.setFocus();
        return false;
      }
      if (!this.entity.newPassword) {
        this.$refs.newPassInput.showErrorMessage();
        this.$refs.newPassInput.setFocus();
        return false;
      }
      if (!this.entity.confirmNewPassword) {
        this.$refs.newConfirmPassInput.showErrorMessage();
        this.$refs.newConfirmPassInput.setFocus();
        return false;
      }
      if (this.entity.newPassword !== this.entity.confirmNewPassword) {
        this.$refs.newConfirmPassInput.showErrorMessage();
        this.$refs.newConfirmPassInput.setFocus();
        return false;
      }
      return true;
    },
    async changePassword() {
      if (!this.validate()) {
        return;
      }
      let that = this;

      // that.entity.recaptchaToken = await that.generateRecaptchaToken();
      await axios
        .post('/Security/Account/ChangePasswordForSite', that.$data.entity)
        .then((response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            that.modalHasError = true;
            that.modalError = errorMessages;
            return;
          }

          that.$refs.notification.show({
            type: 'success',
            title: `رمز عبور با موفقیت تغییر پیدا کرد`,
          });
          that.cancelModal();
          that.$store.dispatch('logout').then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          if (!error.response.data.success) {
            that.modalHasError = true;
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            that.modalError = errorMessages;
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
          }
        });
    },
  },
  async mounted() {
    const route = useRoute();
    let that = this;
    // that.clientID = -1; // route.params.id;
    that.clientID = route.params.id;

    that.changePasswordModal = new Modal(
      document.getElementById('changePasswordModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    await this.getProfilePicture();
    // await this.getDiscountCodeData();
  },
};
</script>

<style scoped>
.image {
  opacity: 1;
  display: block;
  width: 100%;
  max-height: 180px;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.imageContainer:hover .image {
  opacity: 0.3;
}

.imageContainer:hover .middle {
  opacity: 1;
}

.text {
  /* background-color: #4c5e74 !important; */
  /* color: white; */
  color: #4c5e74 !important;

  font-size: 16px;
  /* padding: 5px 20px; */
}
.deleteBtn {
  position: absolute;
  top: 0%;
  left: 0%;
  z-index: 3 !important;
}
</style>
